/**
 * Device sizes offered by the preview toolbars, portrait-first.
 *
 * These are the frames the playables are actually reviewed against, so a
 * preview should be able to sit at each of them exactly rather than being
 * dragged to something approximate. The playable lays itself out for the pixel
 * size it is given, so a preview that keeps only the aspect ratio and fits the
 * pane is showing a different device than the one its icon promises — the
 * frames here are rendered at these exact pixel sizes and CSS-scaled to fit.
 *
 * Shared by the version preview (`containerGamePreview`) and the snapshot
 * editor preview so both editors review against the same frames.
 */
export const DEVICE_PRESETS = [
  { id: "iphone-se", label: "iPhone SE", width: 375, height: 667 },
  { id: "iphone-x", label: "iPhone X", width: 414, height: 896 },
  { id: "ipad-air", label: "iPad Air", width: 820, height: 1180 }
];

export const DEFAULT_DEVICE_ID = DEVICE_PRESETS[0].id;

export function devicePresetById(deviceId) {
  return DEVICE_PRESETS.find((preset) => preset.id === deviceId) || DEVICE_PRESETS[0];
}

/**
 * The preset's pixel size for the requested orientation. Landscape swaps the
 * pair, so a preset stored portrait-first answers both.
 */
export function orientedDeviceSize(preset, isPortrait) {
  const shortEdge = Math.min(preset.width, preset.height);
  const longEdge = Math.max(preset.width, preset.height);
  return isPortrait ? { width: shortEdge, height: longEdge } : { width: longEdge, height: shortEdge };
}

/** Zoom steps the preview toolbars offer, on top of "Fit". */
export const ZOOM_STEPS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2];

const ZOOM_MIN = ZOOM_STEPS[0];

const ZOOM_MAX = ZOOM_STEPS[ZOOM_STEPS.length - 1];

export const ZOOM_FIT = "fit";

export function clampZoom(value) {
  return Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, value));
}

/**
 * Stage padding plus the room the handles need outside the frame. The fit maths
 * and the drag clamp both measure against it, so they agree on what "inside the
 * stage" means.
 */
export const STAGE_INSET = 40;
